import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    padding: `${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(
      4
    )}px ${theme.spacing(4)}px !important`,
    textAlign: 'left',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
  title: {
    fontWeight: 400,
    fontSize: 24,
    ...theme.headerFont,
  },
  logo: {
    maxWidth: 200,
  },
  topic: {
    fontSize: 16,
    textAlign: 'left',
    width: '100%',
  },
  greyBg: {
    width: '100%',
    backgroundColor: '#FAFAFA',
    borderRadius: 6,
    padding: theme.spacing(2),
    '& p': {
      margin: 0,
    }
  }
}))

const CourierDetailModal = ({
  isOpen,
  setOpen,
  courierLogo,
  courierName,
  courierCondition,
  courierDetail,
}) => {
  const classes = useStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { t } = useTranslation('common')

  const renderCourierDetail = () => {
    if (!Array.isArray(courierDetail)) return courierDetail
    return (
      <ul>
        {courierDetail.map((text,index) => (
          <li key={index}>{text}</li>
        ))}
      </ul>
    )
  }

  const renderCourierCondition = () => {
    if (!Array.isArray(courierCondition)) return courierCondition
    return (
      <ol>
        {courierCondition.map((text,index) => (
          <li key={index}>{text}</li>
        ))}
      </ol>
    )
  }

  return (
    <Dialog onClose={() => setOpen(false)} open={isOpen} maxWidth="md" fullWidth fullScreen={isMobile}>
      <DialogContent className={classes.content}>
        <IconButton
          className={classes.closeButton}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
        <img src={courierLogo} alt={courierName} className={classes.logo} />
        <h1 className={classes.title}>{courierName}</h1>
        {
          courierDetail && (
            <div className={classes.greyBg}>
              <p>{renderCourierDetail()}</p>
            </div>
          )
        }
        {
          courierCondition && (
            <>
              <h2 className={classes.topic}>{t('term-of-usages')} {courierName}</h2>
              <div className={classes.greyBg}>
                <p>{renderCourierCondition()}</p>
              </div>
            </>
          )
        }
      </DialogContent>
    </Dialog>
  )
}

export default CourierDetailModal
